export default "__VITE_ASSET__BSh3xp$W__"